import React, { useState, useEffect } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";

import "./tasks.css";
import TaskDrawer from "./TaskDrawer";
import TaskBoard from "./TaskBoard";
import { isAuthenticated } from "../../../commons/Auth/auth";
import { generalErrorAlert } from "../../../commons/GeneralErrorAlert";

const authHeaders = () => ({ Authorization: "Bearer " + localStorage.getItem("token") });

// One board for every screen size: on phones TaskBoard turns the columns into swipeable pages
// with a column switcher and a status picker on each card.
const Tasks = () => {
  const { t } = useTranslation("dashboard");
  const [tasks, setTasks] = useState([]);

  const getTasks = async () => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/tasks/filters`,
        { serviceProvider: isAuthenticated()?.serviceProviderId },
        { headers: authHeaders() }
      );
      setTasks(res.data || []);
    } catch (err) {
      console.error("Error fetching tasks:", err);
      generalErrorAlert(err);
    }
  };

  useEffect(() => {
    getTasks();
  }, []);

  return (
    <div className="desk-wrapper">
      <div className="desk-topbar">
        <div className="desk-topbar__left">
          <h2 className="desk-topbar__title">{t("Tasks Board")}</h2>
          <span className="desk-topbar__count">
            {tasks.length} {t("Tasks")}
          </span>
        </div>
        <TaskDrawer mode="add" updateParent={getTasks} />
      </div>

      <TaskBoard tasks={tasks} onChanged={getTasks} />
    </div>
  );
};

export default Tasks;
